let scrollY = 0;

export function disableScroll() {
  // already locked (two dialogs opening, or a stale listener): a second call would read scrollY 0 and jump to the top
  if (document.body.style.position === 'fixed') return;
  scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

// A modal on screen: Bootstrap (display block while shown or still fading out) or a Vue v-if ".modal" overlay.
// getClientRects: a ".modal" inside a hidden modal (QRDialog in QuoteDetail) has display block but is not rendered.
function anyModalOpen() {
  return [...document.querySelectorAll('.modal')].some(m => m.getClientRects().length > 0);
}

function unlock() {
  // not locked: nothing to restore (otherwise top '' → scroll to 0)
  if (document.body.style.position !== 'fixed') return;
  const y = parseInt(document.body.style.top || '0') * -1;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  // instant: html has scroll-behavior smooth, which animated the page from the top back down on close
  try {
    window.scrollTo({ top: y, behavior: 'instant' });
  } catch (e) {
    window.scrollTo(0, y); // older iOS WebKit rejects behavior 'instant'
  }
}

// Modals open on top of each other (confirm over a modal, modal over a modal) share one page lock. A closing modal
// only unlocks the page when no other modal is left on screen; the check waits a tick so a v-if modal is gone by then.
export function enableScroll() {
  setTimeout(() => {
    if (!anyModalOpen()) unlock();
  });
}

// After a page change (router.afterEach): when no modal is on screen, drop any lock a modal / dialog of the previous page
// left behind (fixed body, html overflow hidden, Bootstrap's body.modal-open + backdrop) — a page that can't scroll is stuck.
export function releaseStaleScrollLock() {
  setTimeout(() => {
    if (anyModalOpen()) return;
    unlock();
    const html = document.documentElement;
    if (html.style.overflow === 'hidden') html.style.overflow = '';
    html.style.paddingRight = '';
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
  }, 300);
}

// <html>.fxScrollLock drives the CSS page lock (eval-figma.css). Kept in sync from the DOM (any modal / overlay shown,
// body.modal-open, disableScroll's fixed body) instead of html:has(...), which iOS Safari left applied after close.
function syncScrollLock() {
  const body = document.body;
  const locked = body.classList.contains('modal-open') || body.style.position === 'fixed'
    || !!document.querySelector('.modal.show, .modals-backdrop');
  document.documentElement.classList.toggle('fxScrollLock', locked);
}
let syncQueued = false;
new MutationObserver(() => {
  if (syncQueued) return;
  syncQueued = true;
  requestAnimationFrame(() => {
    syncQueued = false;
    syncScrollLock();
  });
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });

// A Bootstrap modal that never calls enableScroll itself (or one that fades out after its caller did):
// whichever modal closes last unlocks the page — any page, any modal.
document.addEventListener('hidden.bs.modal', enableScroll);
